const handleScroll = (
  event: React.MouseEvent<HTMLAnchorElement>,
  scrollToId: string,
  offset?: number
) => {
  event.preventDefault();
  const element: HTMLElement | null = document.getElementById(scrollToId);
  if (element) {
    const elementPosition =
      element.getBoundingClientRect().top + window.pageYOffset;
    const offsetScroll = offset || 0;
    let scrollPosition: number = 0;
    if (offsetScroll < 0) {
      scrollPosition = elementPosition + offsetScroll;
    }else {
      scrollPosition = elementPosition - offsetScroll;
    }

    window.scrollTo({
      top: scrollPosition,
      behavior: "smooth",
    });
  }
};

export default handleScroll;
